import FlightMetaData from './FlightMetaData'

export default FlightMetaData
